// extracted by mini-css-extract-plugin
module.exports = {"mobile":"footer_mobile__TMMaS"};